import { api } from "@api/api";
import { ApiResponse } from "@shared/types";
import { Plan } from "@modules/plans/types";

import { ListPlansQueryFilters } from "./types";

/**
 * Busca TODOS os planos de um convênio, percorrendo todas as páginas.
 * A API é paginada — pedir page_size grande em uma página só trunca a lista.
 */
export async function getAllPlansService(
  agreementId: string | number
): Promise<Plan[]> {
  const allResults: Plan[] = [];
  let page = 1;
  const pageSize = 500;
  let hasMore = true;

  try {
    while (hasMore) {
      const { data } = await api.get<ApiResponse<Plan>>(
        `v1/subscription_plan_admin/`,
        {
          params: {
            agreement: agreementId,
            page,
            page_size: pageSize,
          },
        }
      );

      allResults.push(...data.results);
      hasMore = data.next !== null;
      page++;
    }

    return allResults;
  } catch (error) {
    console.error("Error fetching all plans:", error);
    throw error;
  }
}

export async function getPlansService(filters?: ListPlansQueryFilters): Promise<Plan[]> {
  try {
    const { data } = await api.get<ApiResponse<Plan>>(`v1/subscription_plan_admin/`, {
      params: {
        agreement: filters?.agreement,
        page: filters?.page,
        page_size: filters?.perPage,
        search: filters?.search,
        ids: Array.isArray(filters?.ids) ? filters.ids.join(",") : undefined,
      },
    });
    return data.results;
  } catch (error) {
    console.error("Error fetching plans:", error);
    throw error;
  }
}
